<template>
  <div class="tw-flex tw-flex-col tw-gap-2">
    <div class="tw-relative" v-if="companyInfo">
      <select class="fox-input--simple fox-input--simple-select tw-w-full" @change="selectCompany">
        <option selected value="">Rechnungssteller *</option>
        <option :key="companyInfo.uuid" :value="companyInfo.uuid">
          {{ companyInfo.firstName }} {{ companyInfo.lastName }} ({{ companyInfo.companyName }})
        </option>
      </select>

      <div class="tw-absolute tw-inset-y-0 tw-right-1 tw-flex tw-items-center tw-pointer-events-none">
        <v-icon>mdi-menu-down</v-icon>
      </div>
    </div>
    <label class="fox-label--simple" v-else>
      Rechnungssteller <span class="fox-input__require-star">*</span>
    </label>
    <div>
      <input type="text"
        v-model="billerLocal.company"
        class="fox-input--simple tw-w-full"
        :placeholder="placeholder.company"
        v-bind:class="classes.company"
      >
    </div>
    <div>
      <input type="text"
             v-model="billerLocal.name"
             class="fox-input--simple tw-w-full"
             :placeholder="placeholder.name"
             v-bind:class="classes.name"
      >
    </div>
    <div>
      <input type="text"
             v-model="billerLocal.street"
             class="fox-input--simple tw-w-full"
             :placeholder="placeholder.street"
             v-bind:class="classes.street"
      >
    </div>
    <div class="tw-flex tw-gap-2">
      <input type="text"
             v-model="billerLocal.postalCode"
             class="fox-input--simple tw-w-full"
             :placeholder="placeholder.postalCode"
             v-bind:class="classes.postalCode"
      >
      <input type="text"
             v-model="billerLocal.city"
             class="fox-input--simple tw-w-full"
             :placeholder="placeholder.city"
             v-bind:class="classes.city"
      >
    </div>
    <div>
      <input type="text"
        v-model="billerLocal.country"
        class="fox-input--simple tw-w-full"
        :placeholder="placeholder.country"
        v-bind:class="classes.country"
      >
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    biller: {
      type: Object
    },
    companyInfo: {
      type: Object
    }
  },
  emits: ['update:biller'],
  data: function () {
    return {
      billerLocal: { ...this.biller },
      placeholder: {
        company: 'Unternehmen / Rechtsform',
        name: 'Name',
        street: 'Straße und Hausnummer',
        postalCode: 'PLZ',
        city: 'Stadt',
        country: 'Land'
      }
    }
  },
  validations () {
    return {
      billerLocal: {
        name: { required },
        street: { required },
        postalCode: { required },
        city: { required },
        country: { required }
      }
    }
  },
  computed: {
    classes: function () {
      return {
        name: {
          'fox-input--error': this.v$.billerLocal.name.$error
        },
        street: {
          'fox-input--error': this.v$.billerLocal.street.$error
        },
        postalCode: {
          'fox-input--error': this.v$.billerLocal.postalCode.$error
        },
        city: {
          'fox-input--error': this.v$.billerLocal.city.$error
        },
        country: {
          'fox-input--error': this.v$.billerLocal.country.$error
        }
      }
    }
  },
  methods: {
    updateBiller () {
      this.$emit('update', this.billerLocal)
    },
    selectCompany () {
      this.billerLocal.company = this.companyInfo.companyName
      this.billerLocal.name = this.companyInfo.firstName + ' ' + this.companyInfo.lastName
      this.billerLocal.street = this.companyInfo.address
      this.billerLocal.postalCode = this.companyInfo.zipCode
      this.billerLocal.city = this.companyInfo.city
      this.billerLocal.country = this.companyInfo.country
      this.billerLocal.uuid = this.companyInfo.uuid
      this.billerLocal.logoUrl = this.companyInfo.logo
      this.updateBiller()
    }
  },
  watch: {
    biller: {
      handler (newVal) {
        this.billerLocal = { ...newVal }
      },
      immediate: true,
      deep: true
    },
    billerLocal: {
      handler (newVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(this.biller)) {
          this.$emit('update:biller', newVal)
        }
      },
      deep: true
    }
  }
}
</script>
